import React, { useState, useEffect } from 'react';

import { useRecoilState } from 'recoil';
import { tokenAtom } from 'core/config/atoms';

import { ScrollArea } from "@/components/ui/scroll-area";
import { Edit, Trash } from 'lucide-react';

import TopBar from 'core/widgets/ui/TopBar';

import { toast } from 'react-toastify';
import Lottie from 'lottie-react';
import { useFormik } from 'formik';
import axios from 'axios';
import Select from 'react-select';
import { Controlled as ControlledZoom } from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

import animBtnLoading from '../../assets/anim/anim-btnLoading.json';
import animPage from '../../assets/anim/anim-pageload.json';

import ServiceResearch from 'services/serviceResearch';
import ServiceGallery from 'services/serviceGallery';
import ServiceUtility from 'services/serviceUtility';

import { API_URL } from 'services/models/AppConstent';

const allowedExtensions = ["png", "jpeg"];

export default function PanelGallery() {
    const [token] = useRecoilState(tokenAtom);

    const [thubFile, setThubFile] = useState(null);
    const [thubPreview, setThubPreview] = useState(null);

    const [record, setRecords] = useState({});

    const [tags, setTags] = useState([]);
    const [files, setFiles] = useState([]);
    const [options, setOptions] = useState([]);

    const [isOpen, setIsOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isZoomed, setIsZoomed] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [edit, setEdit] = useState(false);

    const [progress, setProgress] = useState(0);
    const [imageIndex, setImageIndex] = useState(-1);

    const researchService = new ServiceResearch();
    const galleryService = new ServiceGallery();
    const utilService = new ServiceUtility();

    const { values, errors, touched, handleChange, handleSubmit, handleReset, setValues } = useFormik({
        initialValues: {
            tags: [],
        },
        enableReinitialze: true,
        onSubmit: values => {
            if (edit) {
                if (tags.length !== 0) {
                    setSubmit(true);
                    let body = {
                        uid: record._id,
                        data: {
                            tags: tags,
                        }
                    }
                    galleryService.updateGallery(body, token).then((res) => {
                        setSubmit(false);
                        if (res.status) {
                            toast.success("Image tags updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                            setIsOpen(false);
                            setEdit(false);
                            setRecords({});
                            loadData();
                            handleReset();
                            setThubFile(null);
                            setThubPreview(null);
                        } else {
                            toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                        }
                    });
                }
            } else {
                if (thubFile !== null && tags.length !== 0) {
                    setSubmit(true);
                    var formData = new FormData();
                    formData.append("path", 'gallery');
                    formData.append("doc", thubFile);
                    fnSubmit(formData, token);
                } else {
                    toast.error('Please select values for image.', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            }
        },
    });

    const fnSubmit = (data, token) => {
        (async function () {
            setProgress(0);
            var url = `${API_URL}file/uploadFile`;
            var requestHeaders = {
                'Content-type': 'multipart/form-data',
                'Accept': '*/*',
                'Authorization': `bearer ${token}`,
            };

            const responseFile = await axios.post(url, data, {
                headers: requestHeaders,
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    setProgress(progress);
                },
            });
            let resFile = responseFile.data.data;
            setProgress(0);
            let body = {
                tags: tags,
                files: resFile,
            }
            galleryService.setGallery(body, token).then((res) => {
                setSubmit(false);
                if (res.status) {
                    toast.success("New image added!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    setIsOpen(false);
                    loadData();
                    handleReset();
                    setThubFile(null);
                    setThubPreview(null);
                } else {
                    toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            });
        })();
    }

    const handleFileChange = (e) => {
        var { value, name } = e.target;
        let isError = false;

        const inputFile = e.target.files[0];
        const fileExtension = inputFile?.type.split("/")[1];

        if (!allowedExtensions.includes(fileExtension)) {
            alert.show("Only .png file format is allowed, please try again!", { type: 'error' });
            isError = true;
        }

        if (isError) {
            return;
        }

        setThubFile(inputFile);

        const reader = new FileReader();
        reader.onload = () => {
            setThubPreview(reader.result);
        };
        reader.readAsDataURL(inputFile);
    };

    const handleZoomChange = (shouldZoom, selIndex) => {
        if (shouldZoom) {
            setImageIndex(selIndex);
            setIsZoomed(shouldZoom);
        } else {
            setImageIndex(-1);
            setIsZoomed(shouldZoom);
        }
    }

    const deleteFile = (fileurl, id) => {
        setSubmit(true);
        let bodyA = { "path": fileurl }
        utilService.deleteFile(bodyA, token).then((res) => {
            let body = {
                "rid": id,
            };
            galleryService.delGallery(body, token).then((res) => {
                toast.success(`1 File Deleted`, { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                setSubmit(false);
                loadData();
                handleReset();
                loadData();
            });
        });
    }

    const editFile = (rec) => {
        setRecords(rec);
        setTags(rec.tags);
        let tempList = [];
        rec.tags.map((item) => {
            const otp = options.find((e) => item === e.value);
            tempList.push(otp);
        });
        setValues({ ...values, tags: tempList });
        setEdit(true);
        setIsOpen(true);
    }

    const loadData = () => {
        setLoading(true);
        (async function () {
            let body = {
                "filter": {},
                "page": 0,
                "size": 0,
                "searchQuery": "",
                "startDate": "",
                "endDate": ""
            };

            var docRec = await galleryService.getAllGallery(body, token);
            setFiles(docRec.data.data);

            var doc = await researchService.getAllResearch(body, token);
            let ops = [
                { value: 'ws', label: 'Workshop-School' },
                { value: 'wc', label: 'Workshop-Collage' },
                { value: 'wt', label: 'Workshop-Teacher' },
                { value: 'cp', label: 'Corporate-Program' }
            ]
            doc.data.data.map((item) => {
                ops.push({ value: item._id, label: `${item.title} - Resarch Page` });
            })
            setOptions(ops);
            setLoading(false);
        })();
    }

    useEffect(() => {
        loadData();
    }, []);

    return (
        <div className="w-full h-full py-3 px-3">
            {
                loading && <div className='flex items-center justify-center w-full h-full'>
                    <Lottie animationData={animPage} className="w-40 h-40" loop={true} />
                </div>
            }
            {
                isOpen && <div className='overflow-y-auto overflow-x-hidden z-50 w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] absolute right-0 min-h-screen p-[20px]'>
                        <ScrollArea>
                            <div className='px-4 min-h-screen'>
                                <div className='flex items-center justify-between text-2xl'>
                                    <h1 className='font-sans font-medium text-gray-900'>New Image</h1>
                                    <span onClick={() => {
                                        setIsOpen(false);
                                        setEdit(false);
                                        setRecords({});
                                        handleReset();
                                        setThubFile(null);
                                        setThubPreview(null);
                                        loadData();
                                    }}><i className="las la-times text-xl text-gray-700 cursor-pointer"></i></span>
                                </div>
                                <hr className='my-4' />
                                <div className="mb-8 space-y-4">
                                    <div className="w-full">
                                        <label className="block text-xs font-medium text-gray-700 font-mono mb-1">Select Pages<sup className="text-red-600">*</sup></label>
                                        <Select closeMenuOnSelect={false} onChange={(e) => {
                                            let list = [];
                                            setValues({ ...values, tags: e });
                                            e.map((item) => {
                                                list.push(item.value);
                                            });
                                            setTags(list);
                                        }} isMulti options={options} className="block w-full bg-white text-sm" value={values.tags} />
                                    </div>

                                    {
                                        !edit && <div className="mb-6">
                                            <label className="block mb-2 text-sm font-medium text-gray-600">Thumbnail File</label>
                                            {
                                                (thubFile === null) && <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                                                    <div className="space-y-1 text-center">
                                                        <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                                            <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                        <div className="flex text-sm text-gray-600">
                                                            <label className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                                                <span>Upload a file</span>
                                                                <input type="file" className="sr-only" onChange={handleFileChange} />
                                                            </label>
                                                            <p className="pl-1">or drag and drop</p>
                                                        </div>
                                                        <p className="text-xs text-gray-500">
                                                            .jpg or .png up to 2mb at 16:9 Ration
                                                        </p>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                thubFile !== null && <div className="pl-3 pr-4 py-3 flex items-center justify-between text-sm bg-gray-100 rounded border mt-2">
                                                    <div className="w-0 flex-1 flex items-center">
                                                        <img src={thubPreview} alt="Icon Template" className='w-10 h-10' />
                                                        <span className="ml-2 flex-1 w-0 truncate flex items-center">
                                                            {thubFile.name}&nbsp;
                                                            <i className="las la-link text-gray-400 text-lg"></i>
                                                        </span>
                                                    </div>
                                                    <div className="ml-4 flex-shrink-0">
                                                        <label className="relative cursor-pointer rounded-md font-medium text-indigo-600 font-mono">
                                                            <span>Replace</span>
                                                            <input type="file" className="sr-only" onChange={handleFileChange} />
                                                        </label>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }

                                    {
                                        submit && <div className='my-3'>
                                            <p className='text-xs text-gray-400'>Uploading....</p>
                                            <div className='w-full bg-gray-300 mt-1' style={{ height: '4px' }}>
                                                <div style={{ width: `${progress}%`, transitionDuration: `4s` }} className="h-full transition-all bg-green-400"></div>
                                            </div>
                                        </div>
                                    }
                                </div>
                                <div className='w-full'>
                                    <button type="button" className="w-full text-white bg-primeLight hover:bg-prime focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center" disabled={submit} onClick={() => { handleSubmit() }} >
                                        {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                        {!submit && edit ? "Update Image" : "Add Image"}
                                    </button>
                                </div>
                            </div>
                        </ScrollArea>
                    </div>
                </div>
            }
            <ScrollArea className="w-full h-full py-3 px-3">
                <div className="grid grid-cols-12 grid-gap-2 pb-20">
                    <div className="col-span-12 mt-2">
                        <div class="intro-y flex items-center justify-between h-10">
                            <h2 class="text-2xl font-medium truncate ml-2">
                                Gallery Master
                            </h2>
                            <div className='flex z-50'>
                                <button className="py-1 px-3 h-10 rounded-md bg-prime hover:bg-primeLight text-white mr-4" onClick={() => { setIsOpen(true); }}><i className="las la-plus mr-2"></i> Add Image</button>
                                <TopBar />
                            </div>
                        </div>
                    </div>
                    <hr className='mt-4 col-span-12' />
                    {
                        files.length === 0 && <div className="intro-y mt-6 col-span-12 flex items-center justify-center">
                            <p>No Data Found.</p>
                        </div>
                    }
                    <div className='col-span-12 grid grid-cols-6 gap-4'>
                        {
                            files.length !== 0 && files.map((fil, index) => {
                                return <div className='intro-y col-span-1 border rounded-md my-4' key={fil._id}>
                                    <div className='w-[28px] h-[28px] absolute bottom-[6px] left-[6px] z-50 bg-red-100 text-red-800 flex items-center justify-center rounded-full cursor-pointer' onClick={() => { deleteFile(fil.files.fileurl, fil._id) }}>
                                        <Trash size={18} className="" />
                                    </div>
                                    <div className='w-[28px] h-[28px] absolute bottom-[6px] left-[40px] z-50 bg-blue-100 text-blue-800 flex items-center justify-center rounded-full cursor-pointer' onClick={() => { editFile(fil) }}>
                                        <Edit size={18} className="" />
                                    </div>
                                    <ControlledZoom isZoomed={isZoomed} onZoomChange={(shouldZoom) => { handleZoomChange(shouldZoom, index); }}>
                                        <img src={fil.files.fileurl} alt="item" className='cursor-pointer rounded-md' />
                                    </ControlledZoom>
                                </div>
                            })
                        }
                    </div>
                </div>
            </ScrollArea>
        </div>
    )
}
